module.exports = __webpack_public_path__ + "/11dd4c73493d0eafa272bbf58cd02f3f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/x@2x.png
 ** module id = 700
 ** module chunks = 0
 **/